<p-toast position="top-right" key="tc"></p-toast>

<div class="flex align-items-start flex-column lg:justify-content-between lg:flex-row mt-1">
    <div class="font-medium text-xl text-900">Profil bearbeiten

    </div>
</div>

<p-divider></p-divider>

@if (loading) {

<p class="font-medium text-xl text-900"><i class="pi pi-spin pi-spinner mr-2"></i><span>Bitte warten - Daten werden
        geladen....</span>
    <p-divider></p-divider>
</p>
} @else {

<div>

    <div class="grid">
        <div class="col-6">
            <div>
                <div class="font-medium text-l text-900 mb-2">Auswahl Theme (Farben / Aussehen)</div>
                <p-dropdown name="selectedTheme" id="selectedTheme" [options]="themes" styleClass="w-full"
                    [(ngModel)]="selectedTheme" optionLabel="longname" optionValue="name" [filter]="true"
                    filterBy="longname" [showClear]="true" placeholder="Bitte ein Theme auswählen!"></p-dropdown>
            </div>
            <div class="grid">
                <div class="col-6">
                    <p-button label="Vorschau" styleClass="p-button-raised mt-2 w-full" icon="pi pi-eye"
                        (click)="previewTheme()"></p-button>
                </div>
                <div class="col-6">
                    <p-button label="Speichern" styleClass="p-button-raised mt-2 w-full p-button-success"
                        icon="pi pi-save" (click)="setTheme()"></p-button>
                </div>
            </div>
        </div>
    </div>
    <p-divider></p-divider>
    <div class="grid">
        <div class="col-6">
            <form (ngSubmit)="savePassword()" [formGroup]="passwordForm">
                <h4>Kennwort ändern</h4>

                <div class="field">
                    <label for="password">Passwort</label>
                    <!-- <input id="password" type="password" name="password" id="password" 
                       > -->

                    <p-password formControlName="password" styleClass="w-full" inputStyleClass="w-full" 
                        promptLabel=" "
                        required weakLabel="Zu einfach" 
                        mediumLabel="Mittlere Sicherheit" 
                        strongLabel="Hohe Sicherheit - Hervorragend!"
                        strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{10,})"
                        [toggleMask]="true" 
                        feedback="true">
                        <ng-template pTemplate="header">
                            <h5>Bitte ein neues Passwort eingeben</h5>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <p-divider />
                            <p class="mt-2">Hinweis</p>
                            <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                                <li>Mindestens einen Großbuchstaben</li>
                                <li>Mindestens einen Kleinbuchstaben</li>
                                <li>Mindestens eine Nummer</li>
                                <li>Wenn möglich ein Sonderzeichen (! oder - oder + oder ähnliches)</li>
                                <li>Mindestens 10 Zeichen</li>
                            </ul>
                        </ng-template>
                    </p-password>
                    <!-- <div *ngIf="formerror.password_confirmation"><small class="p-error">{{ formerror.password_confirmation[0] }}</small></div> -->
                </div>
                <div class="field">
                    <label for="password_confirmation">Passwort wiederholen</label>
                    <input id="password_confirmation" type="password" name="password_confirmation" class="w-full"
                        formControlName="password_confirmation" id="password_confirmation" pInputText required>
                </div>
                @if (errorMessages['password_confirmation'])
                {
                <div class="mb-2">
                    @for (message of errorMessages['password_confirmation']; track message) {
                    <small class="p-error">{{ message
                        }}<br></small>
                    }
                </div>
                }

                <div class="p-fluid">
                    <p-button label="Passwort speichern" (click)="savePassword()" icon="pi pi-save"></p-button>
                </div>
            </form>
        </div>
    </div>
    <p-divider></p-divider>
</div>
}